import { boot } from 'quasar/wrappers'

const format = (amount) => {
  const formatter = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2,
  })

  return formatter.format(amount)
}

export default boot(({ app }) => {
  const currency = {
    format,
  }
  app.config.globalProperties.$currency = currency
})

